(function() {
    'use strict';

    function pntyGetSrcParam() {
        var search_str = window.location.search.substr(1);
        var query_args = search_str.split('&');
        for (var i = 0; i < query_args.length; i++) {
            var arg_parts = query_args[i].split('=');
            if (decodeURIComponent(arg_parts[0]) === 'pnty_src') {
                return decodeURIComponent(arg_parts[1]);
            }
        }
        return;
    }

    if(typeof PNTY_CONFIG != "undefined") {
	    if (PNTY_CONFIG.org.length && PNTY_CONFIG.id.length) {
	    	var d = document;
	        var referrer = '';
	        var pnty_src_param = pntyGetSrcParam();
	        if (typeof pnty_src_param !== 'undefined') {
	            referrer = pnty_src_param;
	        } else {
	            referrer = d.referrer;
	        }

	        var trk_el = d.createElement('img');
	        var apply_system_url = 'https://pnty-apply.ponty-system.se';
	        // opts.org skall vara systemslug. T ex wiseitse / devsearchse.
	        // opts.id är uppdragsid/annonsid.
	        trk_el.setAttribute('src', apply_system_url + '/' + PNTY_CONFIG.org + '/trk/' + PNTY_CONFIG.id + '?r=' + referrer);
	        trk_el.setAttribute('style', 'display: none');

	        d.body.appendChild(trk_el);
	    }
	}

})();